import { schema } from 'normalizr';
import { renameProperty, guid } from 'utils/object';
import { INFORMATION_CONTENT } from 'constants/questionTypes';
import { getInitialQuestionResponse } from 'store/initialState';
import content from './content';

const question = new schema.Entity(
  'questions',
  {
    instructions: [content],
    hints: [content],
    children: [content],
    correctFeedback: [content],
    incorrectFeedback: [content],
    questionContent: [content]
  },
  {
    processStrategy: (value, parent) => {
      let result = {
        ...value,
        correctFeedback: [],
        incorrectFeedback: [],
        questionContent: [],
        children: [],
        sectionId: parent.id,
        score: 0,
        hasBeenOpened: false,
        isAnswered: false,
        isAnsweredCorrectly: false,
        response: getInitialQuestionResponse(value.type),
        affectsProgress: value.type !== INFORMATION_CONTENT
      };

      if (result.hasOwnProperty('isSurvey') && result.affectsProgress) {
        result.affectsProgress = !result.isSurvey;
      }

      if (result.hasCorrectFeedback) {
        result.correctFeedback.push({ id: guid() });
      }

      if (result.hasIncorrectFeedback) {
        result.incorrectFeedback.push({ id: guid() });
      }

      if (result.hasContent) {
        result.questionContent.push({ id: guid() });
      }

      if (result.learningContents) {
        result.learningContents.forEach(learnContent =>
          learnContent.children.length
            ? learnContent.children.forEach(child => result.children.push({ id: child.id }))
            : null
        );
      }

      if (result.questionInstructions) {
        result.questionInstructions.forEach(instruction =>
          instruction.children.length
            ? instruction.children.forEach(child => result.children.push({ id: child.id }))
            : null
        );
      }

      renameProperty(result, 'questionInstructions', 'instructions');
      renameProperty(result, 'learningContents', 'hints');
      delete result.hasCorrectFeedback;
      delete result.hasIncorrectFeedback;
      delete result.hasContent;
      return result;
    }
  }
);

export default question;
